/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {BookingCalendarPageComponent} from './booking-calendar-page.component';


export function bookingCalendarStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.booking-calendar', {
          url: '/booking-calendar',
          views: {
            'content@app': {
              component: BookingCalendarPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Booking Calendar"
          }
        });
  return states.build();
}